import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxFlagIconCssModule } from 'ngx-flag-icon-css';
import { AgmCoreModule } from '@agm/core';

import * as fromComponents from './components';
import * as fromContainers from './containers';
import * as fromPipes from './pipes';
import * as fromDirectives from './directives';
import { SentanceCasePipe } from './pipes';

@NgModule({
  declarations: [
    ...fromContainers.containers,
    ...fromComponents.components,
    ...fromPipes.pipes,
    ...fromDirectives.directives
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AgmCoreModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgxFlagIconCssModule,
    ...fromContainers.containers,
    ...fromComponents.components,
    ...fromPipes.pipes,
    ...fromDirectives.directives
  ],
  providers: [SentanceCasePipe],
  entryComponents: [
    ...fromComponents.entryComponent,
    ...fromContainers.entryComponents
  ]
})
export class SharedModule {}
